import React, { Component } from 'react';
import PropTypes from 'prop-types';
import VgClientPlacedAd from './VgClientPlacedAd';

/* eslint-disable */
export default class AdPlacement extends Component {
    static propTypes = {
        types: PropTypes.arrayOf(PropTypes.string).isRequired,
        clientPlacedAds: PropTypes.arrayOf(PropTypes.object).isRequired,
    };

    render() {
        const ads = this.props.types.map(type => (
            <VgClientPlacedAd
                key={type}
                subtype={type}
                clientPlacedAds={this.props.clientPlacedAds}
            />
        ));

        return <div className="board_ads">{ads}</div>;
    }
}
/* eslint-disable */



/** WEBPACK FOOTER **
 ** ./src/local-components/Ads/AdPlacement.js
 **/